import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body11 from "./Body11";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageProjektyBody11() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body11/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageProjektyBody11;
